import { BLOG_SLUGS } from "@listou/shared/constants";
import { createFileRoute, Link } from "@tanstack/react-router";

import { SiteFooter, SiteHeader } from "../components/site-header";
import { BLOG_POSTS } from "../lib/blog";
import { formatDay } from "../lib/format";
import { seo } from "../lib/head";

export const Route = createFileRoute("/blog/")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Le blog Listou : listes de cadeaux, naissance, Noël, Secret Santa · Listou",
      description:
        "Guides et comparatifs pour choisir et réussir sa liste de naissance, d'anniversaire ou de Noël, et organiser un Secret Santa (Père Noël secret). Des faits vérifiés et datés.",
    }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <div className="min-h-dvh">
      <SiteHeader signedIn={false} />
      <main className="mx-auto grid max-w-4xl gap-10 px-4 pt-10 pb-20 sm:px-6">
        <header className="grid gap-4">
          <h1 className="text-4xl font-medium sm:text-5xl">Le blog Listou</h1>
          <p className="max-w-[56ch] text-xl text-ink/80">
            Pour choisir sa liste de cadeaux, la remplir et la partager, de la naissance au Secret
            Santa de Noël.
          </p>
        </header>
        <ul className="grid gap-4">
          {BLOG_SLUGS.map((slug) => (
            <li key={slug}>
              <Link
                to="/blog/$slug"
                params={{ slug }}
                className="panel grid gap-2 p-6 transition hover:-translate-y-0.5"
              >
                <span className="text-2xl font-semibold">{BLOG_POSTS[slug].h1}</span>
                <span className="text-muted">{BLOG_POSTS[slug].seoDescription}</span>
                <span className="text-sm text-muted">
                  Mis à jour le {formatDay(BLOG_POSTS[slug].updatedOn)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </main>
      <SiteFooter />
    </div>
  );
}
